import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import Svg from 'components/util/Svg'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_ownEveryMile.css'
import messages from './messages'
import flavorScreens from './screens'

function OwnEveryMile (props) {
  const {
    site,
  } = props

  const {
    slug,
    appStoreLink,
    shortName,
  } = site

  const caption = messages.caption[slug] || messages.caption.default
  const title = messages.title[slug] || messages.title.default
  const screenList = flavorScreens[slug] || flavorScreens.fitness
  const screens = screenList.map((src, i) => <img key={i} className={styles.screen} src={src} />)

  const contentStyles = {
    color: 'white',
    align: 'center',
  }

  const flavorClass = styles[slug] || ''

  return (
    <div className={`${styles.ownEveryMile} ${flavorClass}`}>
      <div className={styles.content}>
        <Title {...contentStyles}>
          { title ? <FormattedMessage {...title} /> : null }
        </Title>
        <Caption {...contentStyles}>
          { caption ? <FormattedMessage {...caption} /> : null }
        </Caption>
        <ul className={styles.appStoreLinks}>
          <li className={styles.appStoreLink}>
            <a target='_blank' rel='noopener noreferrer' href={appStoreLink}>
              <Svg className={styles.appStoreIcon} name='apple-app-store' />
            </a>
          </li>
          <li className={styles.appStoreLink}>
            <a target='_blank' rel='noopener noreferrer' href={`https://play.google.com/store/apps/details?id=com.${shortName}.android2&hl=en`}>
              <Svg className={styles.appStoreIcon} name='google-play-store' />
            </a>
          </li>
        </ul>
        <div className={styles.availability}>
          <p className={styles.availabilityTitle}>
            <FormattedMessage
              id='appPage.ownEveryMile.availabilityTitle'
              defaultMessage='Also Available On'
            />
          </p>
          <ul className={styles.availabilityList}>
            <li className={styles.availabilityListItem}>
              <FormattedMessage
                id='appPage.ownEveryMile.availability.appleWatch'
                defaultMessage='Apple Watch'
              />
            </li>
            <li className={styles.availabilityListItem}>
              <FormattedMessage
                id='appPage.ownEveryMile.availability.androidWear'
                defaultMessage='Android Wear'
              />
            </li>
            <li className={styles.availabilityListItem}>
              <FormattedMessage
                id='appPage.ownEveryMile.availability.samsungGear'
                defaultMessage='Samsung Gear'
              />
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.screens}>{screens}</div>
      <div className={styles.midground} />
    </div>
  )
}

OwnEveryMile.propTypes = {
  site: PropTypes.object,
}

export default OwnEveryMile



// WEBPACK FOOTER //
// ./src/components/app-page/own-every-mile/index.jsx